var Pastebin = require('pastebin');
var FileWrapper = require('filewrapper');
var FileInlineView = require('fileinlineview');
var FileTreeView = require('filetreeview');


var BufferUploadView = Backbone.View.extend({
    tagName: 'form',
    className: 'upload',
    input: null,
    events: {
        'submit': 'submit',
        'click input[type=file]': 'inputClick',
        'change input': 'inputChange'
    },
    initialize: function (options, input) {
        this.input = input;
        this.model.bind('uploadPrompt', this.prompt, this);
        this.model.bind('upload', this.upload, this);
        this.model.bind('finaliseFileFromPromise', this.finaliseFileFromPromise, this);
        this.listenTo(this.model.session, 'uploadStart', this.uploadStart);
        this.listenTo(this.model.session, 'uploadConfirmed', this.uploadConfirmed);
        this.listenTo(this.model.session, 'uploadProgress', this.uploadProgress);
        this.listenTo(this.model.session, 'uploadFinalise', this.uploadFinalise);
        this.listenTo(this.model.session, 'uploadSuccess', this.uploadSuccess);
        this.listenTo(this.model.session, 'uploadCancelled', this.uploadCancelled);
        this.listenTo(this.model.session, 'uploadError', this.uploadError);

        this.filesProgress = {};
        this.filesDoneClass = {};
        this.totalProgress = 0;
        this.currentProgress = 0;
    },
    inputClick: function (e) {
        e.stopPropagation();
    },
    upload: function (options) {
        this.doUpload(options);
    },
    doUpload: function (options) {
        var files = options.files;
        if (files) {
            var origInput = this.input.val();
            var dataUriMatch = FileWrapper.detectDataURI(origInput);
            if (dataUriMatch) {
                var before = dataUriMatch.input.slice(0, dataUriMatch.index);
                var after = dataUriMatch.input.slice(dataUriMatch.index + dataUriMatch[0].length);
                origInput = before + after;
            }
            options.message = origInput;
            FileWrapper.collectFileTree(options.entries, options.files).done(_.bind(function (fileTree, truncated) {
                if (fileTree.length == 1 && !fileTree[0].dir) {
                    // single file
                    var file = fileTree[0];
                    if (window.FileReader && file.size <= Pastebin.MAX_LENGTH_BYTES && FileWrapper.isText(file.type)) {
                        var reader = new window.FileReader();
                        reader.onload = _.bind(function (e) {
                            options.contents = e.target.result;
                            options.file = file;
                            this.model.session.trigger(
                                'pasteConfirm',
                                this.model,
                                options
                            );
                        }, this);
                        reader.readAsText(file);
                    } else {
                        var fileWrap = FileWrapper.fromFile(file, this.model.session);
                        var fileView = new FileInlineView({
                            model: fileWrap
                        });
                        if (options.dataURI) {
                            fileView.localFileData = options.dataURI;
                        }
                        if (fileWrap.isTooLarge()) {
                            this.model.trigger('postError', {
                                message: 'file_too_large',
                                size: fileWrap.get('size')
                            });
                        } else {
                            // Background upload
                            options.reqid = this.model.session.backend._getRequestId();

                            var promise = fileWrap.upload();

                            if (options.immediate) {
                                delete options.message;
                                this.finaliseFileFromPromise(promise, fileView, options);
                            } else {
                                this.input.clear();
                                this.model.session.trigger(
                                    'uploadConfirm',
                                    fileView,
                                    this.model,
                                    options,
                                    _.bind(function (data) {
                                        fileWrap.desiredFilename = data.name;
                                        options.message = data.message;
                                        this.finaliseFileFromPromise(promise, fileView, options);
                                    }, this),
                                    _.bind(function () {
                                        fileWrap.cancelUpload();
                                        this.input.setVal(origInput);
                                        this.input.onInput();
                                        if (options.onCancel) {
                                            options.onCancel();
                                        }
                                    }, this)
                                );
                            }
                        }
                    }
                } else {
                    if (FileWrapper.flattenTree(fileTree).length) {
                        options.fileTree = fileTree;
                        options.truncated = truncated;

                        // Background upload
                        options.reqid = this.model.session.backend._getRequestId();
                        options.session = this.model.session;

                        var fileTreeView = new FileTreeView(options);
                        fileTreeView.uploadFiles();

                        if (options.immediate) {
                            delete options.message;
                            this.finaliseFileTree(fileTreeView, options);
                        } else {
                            this.input.clear();
                            this.model.session.trigger(
                                'batchUploadConfirm',
                                fileTreeView.treeRender,
                                this.model,
                                options,
                                _.bind(function (data) {
                                    options.filenames = data;
                                    options.message = data.message;
                                    this.finaliseFileTree(fileTreeView, options);
                                }, this),
                                _.bind(function () {
                                    fileTreeView.cancelUpload();
                                    this.input.setVal(origInput);
                                    this.input.onInput();
                                    if (options.onCancel) {
                                        options.onCancel();
                                    }
                                }, this)
                            );
                        }
                    }
                }
                this.clear();
            }, this));
        }
    },
    addProgressClass: function (className) {
        $(this.el).closest('.uploadcell').addClass(className);
        $(this.el).closest('.uploadcell').addClass('engaged');
    },
    removeProgressClass: function (className) {
        $(this.el).closest('.uploadcell').removeClass(className);
    },
    uploadStart: function (fileWrap) {
        this.totalProgress += 100;
        if (_.isEmpty(this.filesProgress)) {
            this.removeProgressClass('confirmed');
            this.radialProgress.removeClass('gt50');
            this.currentRadialDeg = 0;
            this.radialProgress.find('.part').css({
                transform: 'none'
            });
        }
        this.filesProgress[fileWrap.getUploadId()] = 0;
    },
    uploadConfirmed: function (fileWrap) {
        $(this.el).closest('.uploadcell').addClass('confirmed');
    },
    uploadProgress: function (fileWrap, evt, percentComplete) {
        this.currentProgress += (percentComplete - this.filesProgress[fileWrap.getUploadId()]);
        this.filesProgress[fileWrap.getUploadId()] = percentComplete;
        var totalPercent = this.currentProgress / this.totalProgress * 100;
        this.removeProgressClass('busy active cancelled error success done');
        this.addProgressClass('active');
        if (this.currentRadialAnimation) {
            this.currentRadialAnimation.stop();
        }
        var targetDeg = totalPercent * 360/100;
        var stepDeg;
        $('<div>').animate({'opacity': 0}, {
            duration: 200,
            progress: _.bind(function (animation, value, remain) {
                this.currentRadialAnimation = animation;
                var diff = targetDeg - this.currentRadialDeg;
                var delta = diff * value;
                stepDeg = this.currentRadialDeg + delta;
                if (stepDeg > 180) {
                    this.radialProgress.addClass('gt50');
                    this.radialProgress.find('.first').css({transform: 'rotate(180deg)'});
                    this.radialProgress.find('.rest').show().css({transform: 'rotate('+stepDeg+'deg)'});
                } else {
                    this.radialProgress.removeClass('gt50');
                    this.radialProgress.find('.first').css({transform: 'rotate('+stepDeg+'deg)'});
                    this.radialProgress.find('.rest').hide();
                }
            }, this),
            always: _.bind(function (animation, jumpedToEnd) {
                this.currentRadialAnimation = null;
                this.currentRadialDeg = stepDeg;
            }, this)
        });
    },
    uploadFinalise: function (fileWrap) {
        if (this.currentProgress) {
            this.removeProgressClass('busy active cancelled error success done');
            this.addProgressClass('busy');
        }
    },
    uploadDone: function (className, fileWrap) {
        this.totalProgress -= 100;
        this.currentProgress -= this.filesProgress[fileWrap.getUploadId()];
        this.filesDoneClass[fileWrap.getUploadId()] = className;
        delete this.filesProgress[fileWrap.getUploadId()];
        if (_.isEmpty(this.filesProgress)) {
            var aggregateClass;
            if (_.contains(this.filesDoneClass, 'error')) {
                aggregateClass = 'error';
            } else if (_.contains(this.filesDoneClass, 'cancelled')) {
                aggregateClass = 'cancelled';
            } else {
                aggregateClass = 'success';
            }
            this.filesDoneClass = {};
            this.removeProgressClass('busy active cancelled error success');
            this.addProgressClass('done');
            this.addProgressClass(aggregateClass);
            setTimeout(_.bind(function () {
                this.addProgressClass('disengaging');
                this.removeProgressClass('busy active cancelled error success done engaged confirmed');
                setTimeout(_.bind(function () {
                    this.removeProgressClass('disengaging');
                }, this), 200);
            }, this), 1000);
        }
    },
    uploadCancelled: function (fileWrap) {
        this.uploadDone('cancelled', fileWrap);
    },
    uploadError: function (fileWrap) {
        this.uploadDone('error', fileWrap);
    },
    uploadSuccess: function (fileWrap) {
        this.uploadDone('success', fileWrap);
    },
    inputChange: function (e) {
        var files = this.file[0].files;
        this.doUpload({
            files: files
        });
    },
    prompt: function () {
        this.file.click();
    },
    submit: function (e) {
        e.preventDefault();
    },
    render: function () {
        this.radialProgress = $('<span class="radialProgress"><span class="part first"></span><span class="part rest"></span></span>');
        var labelId = 'bufferUploadView' + this.model.bid();
        if (this.model.isThread()) {
            labelId += 'Thead';
        }
        this.label = $('<label class="g">').text('Upload a file').attr('for', labelId);
        this.file = $('<input class="g" name="file" type="file" multiple tabindex="-1" aria-hidden="true">').attr('id', labelId);
        $(this.el).append(this.label);
        $(this.el).append(this.file);
        
        this.model.bind('remove', this.remove, this);
        
        return this;
    },
    clear: function () {
        this.file.val('');
    },
    val: function () {
        return this.file.val();
    },
    joinLink: function (message, link) {
        var sep = (_.last(message) == ' ') ? '' : ' ';
        return message + sep + link;
    },
    finaliseFileFromPromise: function (promise, fileView, options) {
        options = options || {};
        fileView.model.triggerBubble('uploadConfirmed');
        var progress = fileView.renderLocalInlineProgress(promise, options);
        if (options.progress) {
            options.progress.replaceWith(progress);
        }
        options.progress = progress;
        fileView.once('finalise', function (retryPromise) {
            options.retry = true;
            this.model.trigger('retryPending', options.reqid);
            this.finaliseFileFromPromise(retryPromise, fileView, options);
        }, this);

        var finalised = new $.Deferred().fail(_.bind(function (errorResponse, msg) {
            fileView.bind('collapsed', function () {
                this.model.trigger('rewriteSayRequest', options.reqid);
            }, this);
            if (errorResponse) {
                this.model.trigger('sayError', errorResponse, msg);
            }
        }, this));

        if (!options.retry) {
            fileView.renderLocalInlinePreview().done(_.bind(function (preview) {
                if (finalised.state() == 'pending') {
                    var localProgress = $('<span class="fileProgress">')
                        .append(options.progress)
                        .append(preview);
                    var extraHtml = $('<span class="fileWrap">').append(localProgress);
                    fileView.setElement(extraHtml);
                    var dummyMessage = fileView.model.dummyUrl();
                    if (options.message) {
                        dummyMessage = this.joinLink(options.message, dummyMessage);
                    }
                    this.model.trigger('sayRequest', dummyMessage, options.reqid, extraHtml);
                    fileView.model.setReqId(this.model, options.reqid);
                }
            }, this));
        }
        promise.done(_.bind(function (uploadResponse) {
            fileView.model.finalise(options, _.bind(function (finaliseResponse) {
                if (finaliseResponse.success) {
                    var msg = fileView.model.getUrl();
                    if (options.message) {
                        msg = this.joinLink(options.message, msg);
                    }
                    this.post(msg, options, _.bind(function (response) {
                        if (response.success) {
                            finalised.resolve();
                        } else {
                            finalised.reject(response, msg);
                        }
                    }, this));
                    this.model.pushInputHistory(msg);
                } else {
                    options.progress.removeClass('busy');
                    options.progress.css('height', 0);
                    finaliseResponse._reqid = options.reqid;
                    finalised.reject(finaliseResponse, true);
                }
            }, this));
        }, this)).fail(_.bind(function (errorString, errorResponse) {
            if (errorString != 'abort') {
                // Can be missing a response if an error was returned before all data was uploaded
                errorResponse = errorResponse || {message: 'upload_error'};
                errorResponse._reqid = options.reqid;
                finalised.reject(errorResponse, true);
            } else {
                finalised.reject();
            }
        }, this));
    },
    post: function (msg, options, callback) {
        return this.model.say(msg, {
            reqid: options.reqid,
            callback: callback,
            silent: true
        });
    },
    finaliseFileTree: function (fileTreeView, options) {
        var finalPromise = fileTreeView.finaliseFiles(options).done(_.bind(function () {
            var finalisedFiles = fileTreeView.processFinalised();
            _.each(fileTreeView.fileViews, function (fileView) {
                fileView.once('finalise', function (retryPromise, thisFileView) {
                    var opts = {
                        reqid: this.model.session.backend._getRequestId()
                    };
                    fileTreeView.removeFile(thisFileView);
                    var newDummyMessage = fileTreeView.dummyMessage(options);
                    this.model.trigger('rewriteSayRequest', options.reqid, newDummyMessage);
                    this.finaliseFileFromPromise(retryPromise, thisFileView, opts);
                }, this);
            }, this);
            if (finalisedFiles.length) {
                var msg = _.map(finalisedFiles, function (file) {
                    return file.getUrl();
                }).join(' ');
                if (options.message) {
                    msg = this.joinLink(options.message, msg);
                }
                this.post(msg, options, _.bind(function (response) {
                    if (!response.success) {
                        this.model.trigger('sayError', response, msg);
                    }
                }, this));
                this.model.pushInputHistory(msg);
            } else {
                this.model.trigger('sayError', {
                    _reqid: options.reqid,
                    message: 'batch_upload_failed'
                }, true);
            }
        }, this));

        fileTreeView.renderLocalInlinePreview(this.model, options).done(_.bind(function (extraHtml) {
            if (finalPromise.state() == 'pending') {
                var dummyMessage = fileTreeView.dummyMessage(options);
                this.model.trigger('sayRequest', dummyMessage, options.reqid, extraHtml);
            }
        }, this));
    }
});

module.exports = BufferUploadView;



//////////////////
// WEBPACK FOOTER
// ./app/src/view/model/bufferuploadview.js
// module id = o1Zz
// module chunks = 1